module.exports = __webpack_public_path__ + "static/media/CC-BY.04d377d9.png";